/**
 * @generated SignedSource<<fe4cabbb8abf788a49a46c40f63121bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarButtons_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SaveSearchButton_viewer">;
  readonly " $fragmentType": "PdpRespSidebarButtons_viewer";
};
export type PdpRespSidebarButtons_viewer$key = {
  readonly " $data"?: PdpRespSidebarButtons_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarButtons_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarButtons_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SaveSearchButton_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "b259abe6d93861bbe6628a748ca13ea2";

export default node;
